/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import isNil from 'lodash/isNil';

import CommunicatorNumber from '../number/communicator-number';
import CommunicatorUtility from '../utility/communicator-utility';

/**
 * @import { FirmwareRelease, ManufacturerModel } from '../../firmware'
 * @import { CommunicatorSettingsGetter } from '../settings/communicator-settings'
 */

/**
 * Komunikátor firmware zařízení pro Ki-Wi Server.
 */
export default class CommunicatorFirmware {
  /**
   * Získá příznak deaktivace firmware.
   * @param {CommunicatorSettingsGetter} communicatorSettings
   * @returns {boolean}
   */
  static getFirmwareDisabled(communicatorSettings) {
    return (
      CommunicatorUtility.parseBoolean(
        communicatorSettings.get('firmware.disabled')
      ) ?? false
    );
  }

  /**
   * Volitelně najde vydání firmware pro zařízení.
   * @param {CommunicatorSettingsGetter} communicatorSettings Komunikátor nastavení ze serveru.
   * @param {ManufacturerModel} manufacturerModel Informace o výrobci a modelu.
   * @returns {FirmwareRelease | undefined} Vydání firmware určené pro zařízení nebo `undefined`, pokud nebylo nalezeno nebo nastala chyba při parsování.
   */
  static getFirmwareRelease(communicatorSettings, manufacturerModel) {
    const { manufacturer, modelName } = manufacturerModel;
    // Do této cesty jsou sdruženy informace odpovídající aktuálnímu firmware.
    const path = `firmware.${manufacturer}.${modelName}`;

    const url = CommunicatorUtility.parseStringOrNull(
      communicatorSettings.get(`${path}.url`)
    );
    if (isNil(url)) {
      return undefined;
    }

    // Kontrola verze k firmware.
    const version = CommunicatorUtility.parseStringOrNull(
      communicatorSettings.get(`${path}.version`)
    );
    if (isNil(version)) {
      return undefined;
    }

    // Položka je volitelná.
    const defaultSizeMiB = CommunicatorNumber.fromStringOrNull(
      communicatorSettings.get(`${path}.defaultSizeMiB`)
    );
    let defaultSize;
    if (!isNil(defaultSizeMiB)) {
      defaultSize = Math.ceil(defaultSizeMiB * 1024 * 1024);
    }

    return { defaultSize, url, version };
  }
}
